export type DocumentKind = 'all' | 'OFFER' | 'INVOICE';
export const documentFilters = ['all', 'today', 'open', 'accepted', 'sent', 'sent-email', 'sent-whatsapp', 'unpaid', 'paid', 'overdue', 'awaiting'] as const;
export type DocumentFilter = typeof documentFilters[number];
export interface DocumentListState { kind: DocumentKind; filter: DocumentFilter; trashMode: boolean }
interface Input { documentKind?: unknown; documentFilter?: unknown; trash?: unknown; tab?: unknown }
interface Saved { kind?: unknown; filter?: unknown; trashMode?: unknown }

export function normalizeDocumentKind(value: unknown): DocumentKind | undefined {
  return value === 'offer' || value === 'OFFER' ? 'OFFER' : value === 'invoice' || value === 'INVOICE' ? 'INVOICE' : value === 'all' ? 'all' : undefined;
}
export function normalizeDocumentFilter(value: unknown): DocumentFilter | undefined {
  const aliases: Record<string, DocumentFilter> = { gesendet: 'sent', gesendet_email: 'sent-email', gesendet_wa: 'sent-whatsapp' };
  return typeof value === 'string' ? aliases[value] ?? (documentFilters.includes(value as DocumentFilter) ? value as DocumentFilter : undefined) : undefined;
}

/** Kind and status are independent. Omitted context preserves the user's list;
 * an explicit kind change resets only an omitted status, never project scope. */
export function resolveDocumentDestination(context: Input = {}, saved: Saved = {}): DocumentListState {
  const savedKind = normalizeDocumentKind(saved.kind) ?? normalizeDocumentKind(saved.filter) ?? 'all';
  const kind = normalizeDocumentKind(context.documentKind) ?? normalizeDocumentKind(context.tab) ?? savedKind;
  const filter = normalizeDocumentFilter(context.documentFilter)
    ?? (kind !== savedKind ? 'all' : normalizeDocumentFilter(saved.filter) ?? 'all');
  return { kind, filter, trashMode: typeof context.trash === 'boolean' ? context.trash : saved.trashMode === true };
}
